module.exports = __webpack_public_path__ + "027.5aaad971.png";